import React from "react";

// components
import AboutImage from "./AboutImage";
import AboutBio from "./AboutBio";

const AboutSection = () => {
	return (
		<div className="py-5 flex flex-col lg:flex-row justify-evenly items-center">
			<AboutBio />
			<AboutImage />
		</div>
	);
};

export default AboutSection;
